import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { ShopActions, NotificationActions } from '../../../store';
import ShopEntryStep1 from './ShopEntryStep1';
import ShopEntryStep2 from './ShopEntryStep2';
import ShopEntryStep3 from './ShopEntryStep3';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopEntry = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    // 表示中の画面NO
    const [activeStep, setActiveStep] = React.useState(0);

    /**
     *
     * 次へ押下時の処理
     *
     */
    const handleNext = () => {
        if (activeStep == 2) {
            // 末端画面（入力内容確認）で登録ボタン押下：登録処理入力内容確認画面で実施）後に一覧へ
            props.onCancel();
        }
        else {
            // 末端画面以前（店舗情報入力、アカウント情報入力）で次へボタン押下：次の画面へ
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    /**
     *
     * 戻る押下時の処理
     *
     */
    const handleBack = () => {
        if (activeStep == 0) {
            // 先頭画面（店舗情報入力）で戻るボタン押下：一覧へ
            props.onCancel();
        }
        else {
            // 先頭画面移行（アカウント情報入力、入力内容確認）で戻るボタン押下：前の画面へ
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    /**
     * 
     * 画面切替
     *
     */
    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                // 店舗情報入力画面
                return <ShopEntryStep1 handleNext={handleNext} handleBack={handleBack} mode="create" merchantId={props.merchantId} />
            case 1:
                // アカウント情報入力画面
                return <ShopEntryStep2 handleNext={handleNext} handleBack={handleBack} mode="create" />
            case 2:
                // 入力内容確認画面
                return <ShopEntryStep3 handleNext={handleNext} handleBack={handleBack} mode="create" />
            default:
                return 'Unknown stepIndex';
        }
    }

    /**
     *
     * 画面のタイトル
     *
     */
    const getTitle = (index) => {
        switch (index) {
            case 0:
                // 店舗情報入力
                return <FormattedMessage id="Shop.CreateTitle" />
            case 1:
                // アカウント情報入力
                return <FormattedMessage id="Account.CreateTitle" />
            default:
                return 'Unknown Title';
        }
    }

    var stepper;
    if (activeStep <= 1) {
        stepper = <div>
            <Stepper className={classes.form} activeStep={activeStep} alternativeLabel>
                <Step key={<FormattedMessage id="Shop.ShopEntryStep1Title" />}>
                    <StepLabel>{<FormattedMessage id="Shop.ShopEntryStep1Title" />}</StepLabel>
                </Step>
                <Step key={<FormattedMessage id="Shop.ShopEntryStep2Title" />}>
                    <StepLabel>{<FormattedMessage id="Shop.ShopEntryStep2Title" />}</StepLabel>
                </Step>
            </Stepper>

            <Toolbar variant="regular">
                <div>
                    <Typography component="h1" variant="inherit">{getTitle(activeStep)}</Typography>
                </div>
            </Toolbar>
        </div>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                {stepper}
                {getStepContent(activeStep)}
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(ShopEntry);
